import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./StudentIdCard3.css";

export default function StudentIdCard3({ data, batch }) {
    const [setting, setSetting] = useState({});

    useEffect(() => {
        setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
    }, []);

    const student = data?.student_info ?? {};

    return (
        <>
            <style>
                {`
                    .student-id-card-3::before {
                        background-image: url(${imgBaseUrl + setting?.logo_img});
                    }
                `}
            </style>

            <div className="student-id-card-3">

                {/* Header */}
                <div className="sid3-header">
                    <img
                        src={imgBaseUrl + setting?.logo_img}
                        className="sid3-logo"
                        alt=""
                    />

                    <div className="sid3-institute-details">
                        <h6>{setting?.name}</h6>

                        <p>
                            {setting?.village} {setting?.district}{" "}
                            {setting?.state}, {setting?.pin_code}
                        </p>

                        <p>
                            Contact : {setting?.mobile}
                            {setting?.secondary_mobile &&
                                `, ${setting?.secondary_mobile}`}
                        </p>

                        <p>Email : {setting?.email}</p>
                    </div>
                </div>

                <div className="sid3-line" />

                {/* Center photo */}
                <div className="sid3-photo">
                    <img
                        src={
                            student?.profile_picture
                                ? imgBaseUrl + student.profile_picture
                                : "/files/user.png"
                        }
                        alt="Student"
                    />
                </div>

                {/* Student details */}
                <div className="sid3-details">

                    <div className="sid3-row">
                        <span>Registration No</span>
                        <span>:</span>
                        <strong>{student?.registration_no || "—"}</strong>
                    </div>

                    <div className="sid3-row fw-900">
                        <span>Name</span>
                        <span>:</span>
                        <strong>{student?.name || "—"}</strong>
                    </div>

                    <div className="sid3-row">
                        <span>Father's Name</span>
                        <span>:</span>
                        <strong>{student?.father_name || "—"}</strong>
                    </div>

                    <div className="sid3-row">
                        <span>Mobile No</span>
                        <span>:</span>
                        <strong>{student?.phone || "—"}</strong>
                    </div>

                    <div className="sid3-row">
                        <span>Course Name</span>
                        <span>:</span>
                        <strong>{batch?.course?.title || "—"}</strong>
                    </div>

                    {/* <div className="sid3-row">
                        <span>Batch Name</span>
                        <span>:</span>
                        <strong>{batch?.title || "—"}</strong>
                    </div> */}

                    <div className="sid3-row">
                        <span>Hostel</span>
                        <span>:</span>
                        <strong>{student?.hostel_status || "—"}</strong>
                    </div>

                    <div className="sid3-address">
                        <span>Address</span>
                        <span>:</span>
                        <strong>
                            {[
                                student?.village,
                                student?.district,
                                student?.state,
                                student?.zipcode,
                            ]
                                .filter(Boolean)
                                .join(", ")}
                        </strong>
                    </div>
                </div>

                {/* Admission date */}
                <div className="sid3-admission-date">
                    Admission Date :{" "}
                    {formatToDate(student?.admission_date)}
                </div>

                {/* Signature */}
                <div className="sid3-signature">
                    <img
                        src={imgBaseUrl + setting?.signature}
                        alt=""
                    />
                    <p>Auth. Signature</p>
                </div>

            </div>
        </>
    );
}
